module.exports = __webpack_public_path__ + "static/media/cert1.9c8223fd.png";